/**
 * Map every backend `WalletVerificationErrorCode` to user-facing copy.
 * Surfaces inline on the onboarding form via `setVerifyError(...)`.
 *
 * Codes are stable across the API/frontend boundary — adding one
 * requires extending this map; renaming one is a breaking change.
 */

import { WALLET_VERIFICATION_ERROR_CODES, type WalletVerificationErrorCode } from "./clientWallets";

export const WALLET_VERIFICATION_ERROR_MESSAGES: Record<WalletVerificationErrorCode, string> = {
    [WALLET_VERIFICATION_ERROR_CODES.CHALLENGE_NOT_FOUND]: "Verification challenge not found — please retry.",
    [WALLET_VERIFICATION_ERROR_CODES.CHALLENGE_EXPIRED]:
        "Verification expired — please paste your wallet address again.",
    [WALLET_VERIFICATION_ERROR_CODES.CHALLENGE_CONSUMED]: "This verification has already been completed.",
    [WALLET_VERIFICATION_ERROR_CODES.SIGNATURE_INVALID]: "Signature didn't verify — please re-sign.",
    [WALLET_VERIFICATION_ERROR_CODES.SIGNER_MUST_MATCH_WALLET]:
        "An EOA wallet can only verify itself. Your connected wallet must match the address you pasted.",
    [WALLET_VERIFICATION_ERROR_CODES.NOT_A_SQUADS_VAULT]: "We couldn't find a Squads multisig at this address.",
    [WALLET_VERIFICATION_ERROR_CODES.UNSUPPORTED_SQUADS_VERSION]: "Only Squads V4 is supported.",
    [WALLET_VERIFICATION_ERROR_CODES.LOOKUP_FAILED]:
        "Verification is temporarily unavailable — please retry in a minute.",
    [WALLET_VERIFICATION_ERROR_CODES.SIGNER_NOT_MULTISIG_MEMBER]:
        "Your connected wallet isn't a member of this multisig.",
    [WALLET_VERIFICATION_ERROR_CODES.SIGNER_LACKS_VERIFY_PERMISSION]:
        "Your connected wallet can't verify this multisig. It needs Vote or Execute permission.",
    [WALLET_VERIFICATION_ERROR_CODES.WALLET_ALREADY_REGISTERED]:
        "This wallet is already registered to a different company recipient.",
    [WALLET_VERIFICATION_ERROR_CODES.CLIENT_NOT_FOUND]: "Company recipient not found.",
    [WALLET_VERIFICATION_ERROR_CODES.ISSUER_ORG_NOT_FOUND]: "Distributor organization not found."
};

export function walletVerificationErrorCopy(code: WalletVerificationErrorCode | "UNKNOWN"): string {
    if (code === "UNKNOWN") {
        return "Something went wrong — please retry.";
    }
    return WALLET_VERIFICATION_ERROR_MESSAGES[code];
}
